export default __webpack_public_path__ + "static/media/logo-cyberid.b909797e.png";